import { useState } from 'react';
import { useStyletron } from 'baseui';
import { Input } from 'baseui/input';
import { COLOURS } from '@gtintel/platform-utils';
export const Title = ({
  text,
  onChange,
  suffix,
  overrides
}) => {
  const [editMode, setEditMode] = useState(false);
  const [css] = useStyletron();
  const suffixElement = <small className={css({
    color: COLOURS.black,
    opacity: '0.5'
  })}>
      {suffix}
    </small>;
  let styles = {
    Root: {
      style: {
        margin: '14px 0'
      }
    }
  };
  if (overrides) {
    styles = {
      ...styles,
      ...overrides
    };
  }
  return editMode ? <Input size="large" value={text} onChange={e => onChange(e.target.value)} onBlur={() => setEditMode(false)} autoFocus onKeyDown={e => {
    if (e.code === 'Escape') {
      setEditMode(false);
    }
  }} overrides={styles} /> : <button className={css({
    margin: '0',
    background: 'none',
    border: 'none',
    width: '100%',
    textAlign: 'left',
    cursor: 'text'
  })} onClick={() => setEditMode(true)}>
      <h2 className={css({
      fontFamily: 'UberMove, UberMoveText, system-ui, "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontSize: '32px',
      lineHeight: '46px',
      margin: '0'
    })}>
        {text} {suffix && suffixElement}
      </h2>
    </button>;
};